

















import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			username: "",
			usernameValidationRule: (v: string) => !!v || this.$t("usernameRequired")
		}
	},
	methods: {
		setUsername(): void {
			const form: any = this.$refs.usernameForm;
			if (form.validate()) {
				this.$emit("new-username", this.username);
				this.username = "";
			}
		}
	}
});
